import { auth } from 'utils/index'

/**
 * Get the document service endpoint URL
 */
export const getDocumentServiceEndpoint = () => {
  return `${process.env.REACT_APP_API_URL}/document`
}

/**
 * Get the authentication token for API requests
 */
export const getAuthToken = (): string => {
  return auth.getJWTToken() || ''
}
